import { Address } from "gql/generated.ts";

export const getAddressString = (
  address: Address,
  includeCoordinates = false,
  includeCountry = true,
) =>
  [
    address.line1,
    address.line2,
    address.city,
    `${address.subdivision ? `${getStateAbbreviation(address.subdivision)} ` : ""}${address.postalCode ? address.postalCode : ""}`.trim(),
    includeCountry ? address.country : null,
    includeCoordinates
      ? // Reverse the coordinates here to match Google Maps format (MapBox format lng / laat)
        `${address.location?.coordinates[1]?.toString()}, ${address.location?.coordinates[0]?.toString()}`
      : null,
  ]
    .filter(item => !!item)
    .join(", ") ?? "";

const getStateAbbreviation = (input: string): string | undefined => {
  const normalized = input.trim().toLowerCase();

  const regionMap: Record<string, string> = {
    // US States
    alabama: "AL",
    alaska: "AK",
    arizona: "AZ",
    arkansas: "AR",
    california: "CA",
    colorado: "CO",
    connecticut: "CT",
    delaware: "DE",
    "district of columbia": "DC",
    florida: "FL",
    georgia: "GA",
    hawaii: "HI",
    idaho: "ID",
    illinois: "IL",
    indiana: "IN",
    iowa: "IA",
    kansas: "KS",
    kentucky: "KY",
    louisiana: "LA",
    maine: "ME",
    maryland: "MD",
    massachusetts: "MA",
    michigan: "MI",
    minnesota: "MN",
    mississippi: "MS",
    missouri: "MO",
    montana: "MT",
    nebraska: "NE",
    nevada: "NV",
    "new hampshire": "NH",
    "new jersey": "NJ",
    "new mexico": "NM",
    "new york": "NY",
    "north carolina": "NC",
    "north dakota": "ND",
    ohio: "OH",
    oklahoma: "OK",
    oregon: "OR",
    pennsylvania: "PA",
    "rhode island": "RI",
    "south carolina": "SC",
    "south dakota": "SD",
    tennessee: "TN",
    texas: "TX",
    utah: "UT",
    vermont: "VT",
    virginia: "VA",
    washington: "WA",
    "west virginia": "WV",
    wisconsin: "WI",
    wyoming: "WY",

    // U.S. Territories
    "american samoa": "AS",
    guam: "GU",
    "northern mariana islands": "MP",
    "puerto rico": "PR",
    "virgin islands": "VI",
    "us virgin islands": "VI",
    "u.s. virgin islands": "VI",
    "u.s. minor outlying islands": "UM",

    // Military "States"
    "armed forces americas": "AA",
    "armed forces europe": "AE",
    "armed forces pacific": "AP",

    // Canadian Provinces & Territories
    alberta: "AB",
    "british columbia": "BC",
    manitoba: "MB",
    "new brunswick": "NB",
    "newfoundland and labrador": "NL",
    newfoundland: "NL",
    nfl: "NL",
    "nova scotia": "NS",
    ontario: "ON",
    "prince edward island": "PE",
    "prince edward is.": "PE",
    pei: "PE",
    quebec: "QC",
    québec: "QC",
    saskatchewan: "SK",
    "northwest territories": "NT",
    nunavut: "NU",
    yukon: "YT",
  };

  // If already a valid abbreviation, return it
  const allAbbreviations = new Set(Object.values(regionMap));
  const upperInput = input.trim().toUpperCase();
  if (allAbbreviations.has(upperInput)) {
    return upperInput;
  }

  // Lookup by full name
  return regionMap[normalized] ?? input;
};
